<template>
    <div>
        <h2 class="title">Access NI Report (Support Workers Only)</h2>

       
        <div class="notification is-warning" v-if="loading == true">
            Loading members ...
        </div>
        <div class="notification is-danger" v-if="loading == false && members.length == 0">
            No active members can be found that require this check
        </div>

        <table class="table is-fullwidth is-hoverable" v-if="loading == false && this.members.length > 0">
            <thead>
                <tr>
                    <th width="50"></th>
                    <th>Forename</th>
                    <th>Surname</th>
                    <th>Received</th>
                    <th>Expiry Date</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in this.sortedMembers" :key="row.id" :class="{'has-background-danger-dark' : row.blocked==1, 'has-text-white' : row.blocked==1}">
                    <td><router-link :to="'/members/' + row.id + '?tab=personal'" target="_blank"><button class="button is-small is-link" >View</button></router-link></td>
                    <td>{{ row.forename }}</td>
                    <td>{{ row.surname}}</td>
                    <td>{{ row.access_ni.received_date }}</td>
                    <td>
                        <span class="tag is-warning" v-if="row.access_ni.calculated_expiry_date == '' || row.access_ni.calculated_expiry_date == null">Not Set</span>
                        <span class="tag is-danger" v-else-if="checkDateExpired(row.access_ni.calculated_expiry_date)">{{ row.access_ni.calculated_expiry_date }}</span>
                        <span class="tag is-success" v-else>{{ row.access_ni.calculated_expiry_date }}</span>
                        </td>
                    
                </tr>
                
                
            </tbody>
            
        </table>

       
    </div>
</template>

<script>
//import MemberService from '@/services/MemberService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

//import MemberGradeTags from '@/components/Generic/MemberGradeTags.vue';

export default {
    
      name: 'MembersDashboard',
        mixins: [MemberMixin],
        components: {
            //MemberGradeTags
        },
        data: function () {
            return {
                   search: '',
                   members: [],
                   loading: false,
                  
                   showModal: false,
                   order_by: "eligibility_form_date ASC"
            }
        },
        methods: {
            
            checkDateExpired(checkDate) {
                if(checkDate != '' && checkDate != null)
                {
                    //const sqlDateParts = checkDate.split('-');
                    
                    const sqlTimestamp = new Date(checkDate); 
                    const targetTimestamp = new Date();


                    let isBeforeTargetDate = sqlTimestamp < targetTimestamp;
                    
                    return isBeforeTargetDate
                }
                else {
                    return false
                }
                
            },
        },
        computed: {
            sortedMembers() {
                return this.members.slice().sort((a, b) => {
                const dateA = new Date(a.access_ni?.calculated_expiry_date || 0);
                const dateB = new Date(b.access_ni?.calculated_expiry_date || 0);
                return dateA - dateB; // ascending order
                });
            }
            },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getSupportWorkers(this.order_by)
            });
        
        },
    }
</script>